import React from "react";

const ExportSvg = () => {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="19"
        height="24"
        viewBox="0 0 19 24"
        fill="none"
      >
        <path
          d="M9.65869 13.1415C10.1126 13.1415 10.4693 12.7805 10.4693 12.3212V2.80554L13.9391 6.3166C14.1013 6.4807 14.2958 6.54639 14.5226 6.54639C14.7497 6.54639 14.9442 6.4807 15.1062 6.3166C15.4305 5.98838 15.4305 5.46353 15.1062 5.16804L10.2422 0.246164C9.91789 -0.0820547 9.39922 -0.0820547 9.10721 0.246164L4.24327 5.16804C3.91891 5.49626 3.91891 6.02111 4.24327 6.3166C4.56762 6.64481 5.08629 6.64481 5.3783 6.3166L8.84803 2.80554V12.3212C8.84803 12.7805 9.20473 13.1415 9.65869 13.1415Z"
          fill="#118BF4"
        ></path>
        <path
          d="M0.622222 24H18.0444C18.3929 24 18.6667 23.68 18.6667 23.2727V8.72727C18.6667 8.32001 18.3929 8 18.0444 8H13.0667C12.7182 8 12.4444 8.32001 12.4444 8.72727C12.4444 9.13454 12.7182 9.45455 13.0667 9.45455H17.4222V22.5455H1.24444V9.45455H5.6C5.94844 9.45455 6.22222 9.13454 6.22222 8.72727C6.22222 8.32001 5.94844 8 5.6 8H0.622222C0.273787 8 0 8.32001 0 8.72727V23.2727C0 23.68 0.273787 24 0.622222 24Z"
          fill="#118BF4"
        ></path>
      </svg>
    </>
  );
};

export default ExportSvg;
